import { useState, useEffect } from 'react';
import {
  Image, Ruler, FileText, CreditCard, Kanban, Calendar, Route, HardHat, Users, Package, Sparkle,
} from '@/components/icons';

// Lifted out of Auth.tsx so AuthShell can use it without importing a page —
// which would be circular, since Auth.tsx renders AuthShell.

const TICKER_FEATURES: { name: string; Icon: typeof Image; maps?: boolean }[] = [
  { name: 'Mockups', Icon: Image },
  { name: 'QuickMeasure', Icon: Ruler },
  { name: 'Estimates & Proposals', Icon: FileText },
  { name: 'Invoicing & Payments', Icon: CreditCard },
  { name: 'CRM & Pipeline', Icon: Kanban },
  { name: 'Scheduling', Icon: Calendar },
  { name: 'Route Planner', Icon: Route, maps: true },
  { name: 'Crew Management', Icon: HardHat },
  { name: 'Client Portal', Icon: Users },
  { name: 'Inventory', Icon: Package },
  { name: 'LumenAI', Icon: Sparkle },
];

export function FeatureTicker() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % TICKER_FEATURES.length), 2600);
    return () => clearInterval(id);
  }, []);
  const feature = TICKER_FEATURES[i];
  const Icon = feature.Icon;
  return (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/55">
        One platform for
      </p>
      <div className="mt-2.5 [perspective:800px]">
        <div key={i} className="lm-flip-in flex items-center gap-3 text-white">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/12 backdrop-blur-sm">
            <Icon className="h-[1.4rem] w-[1.4rem]" />
          </span>
          <span className="text-[1.6rem] font-medium leading-none tracking-tight">{feature.name}</span>
          {feature.maps && (
            <span className="ml-1 flex items-center gap-1.5">
              <img src="/apple-maps-logo.png" alt="Apple Maps" className="h-8 w-8 rounded-lg object-contain" />
              <img src="/google-maps-logo.png" alt="Google Maps" className="h-8 w-8 rounded-lg object-contain" />
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
// dark-mode-guard: fixed-light-file -- decorative content belongs exclusively to the fixed-light AuthShell
